import type { Ref } from 'vue'
import { adminTabClass, type AdminTabVariant } from '../model/admin-tab-class'

/**
 * Tab-button class seam. Binds the currently-active value and a visual variant,
 * returning a `tabClass(value)` the template calls per tab — the active/inactive
 * class decision is delegated to the pure `adminTabClass` core, so panels never
 * value-import `model/`.
 */
export function useAdminTabClass<T extends string>(
  active: Ref<T>,
  variant: AdminTabVariant
): (value: T) => string {
  return (value: T) => adminTabClass(active.value === value, variant)
}
